import Pagination from '@sats-group/ui-lib/react/pagination';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArrowLink from '~/client/components/arrow-link/arrow-link';
import ContentBlocks from '~/client/components/content-blocks/content-blocks';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import PreviewCard from '~/client/components/preview-card/preview-card';
import { aspectRatios } from '~/client/components/preview-card/preview-card.types';
import type { Press as Props } from './press.types';

const Press: React.FC<Props> = ({
  blocks,
  body,
  entries,
  layout,
  links,
  pagination,
  title,
}) => (
  <Layout {...layout}>
    <div className="press">
      <ContentContainer theme={ContentContainer.themes.wide}>
        <div className="press__container">
          <div className="press__header">
            <div className="press__text">
              <Text
                elementName="h1"
                italic
                size={Text.sizes.headline2}
                theme={Text.themes.headline}
              >
                {title}
              </Text>
              {body ? <Text elementName="p">{body}</Text> : null}
            </div>
            <div className="press__links">
              {links.map(entry => (
                <div key={entry.href}>
                  <ArrowLink {...entry} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </ContentContainer>
      <ContentContainer theme={ContentContainer.themes.wide}>
        <div className="press__container">
          <div className="press__entries">
            {entries.map(entry => (
              <div key={entry.href}>
                <PreviewCard {...entry} aspectRatio={aspectRatios.fourFive} />
              </div>
            ))}
          </div>
        </div>
      </ContentContainer>
      {pagination ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <div className="press__container">
            <div className="press__pagination">
              <Pagination {...pagination} navigateOnSelect />
            </div>
          </div>
        </ContentContainer>
      ) : null}
      {blocks ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <ContentBlocks {...blocks} />
        </ContentContainer>
      ) : null}
    </div>
  </Layout>
);

export default Press;
